import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useTranslation } from "react-i18next";
//icons
import {
  FaUserAlt,
  FaBookReader,
  FaHeart,
  FaUserEdit,
  FaSignOutAlt,
  FaShoppingBag
} from "react-icons/fa";
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const DropMenuLogged = (props) => {
  const { t } = useTranslation(['header']);
  const { assignedLibrary } = useAssignedLibrary();

  return (
    <DropdownButton
      drop={props.dropDirection}
      className="btn-logged header__button--logged position-relative"
      size="small"
      id="dropdown-basic-button"
      title={
        <>
          <FaUserAlt className="icon-sm" title={t("myaccount")} />
          <span className={` ${props.sticky ? "d-none" : "d-block"}`}>
            {t("myaccount")}
          </span>
        </>
      }
    >
      <Dropdown.Item as={Link} to={`${assignedLibrary}/perfil`}>
        <FaUserEdit className="icon-sm" />
        {t("myProfile")}
      </Dropdown.Item>
      <Dropdown.Item
        as={Link}
        className="mr-4 d-flex"
        to={`/${assignedLibrary}/mis-libros`}
      >
        <FaBookReader className="icon-sm" color="info" title="Mis Libros" />
        {t("myBooks")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to={`/${assignedLibrary}/favoritos`}>
        <FaHeart className="icon-sm" />
        {t("misFavoritos")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to={`/${assignedLibrary}/order-list`}>
        <FaShoppingBag className="icon-sm" />
        {t("myOrders")}
      </Dropdown.Item>
      <Dropdown.Item onClick={() => props.closeSession()} as={Link} to={'/'}>
        <FaSignOutAlt className="icon-sm" />
        {t("logout")}
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default DropMenuLogged;
